import { useMemo, type ReactNode } from 'react'
import { PreviewFeedContext } from './previewFeedContextValue'
import type { FeedItem, PreviewFeedData } from './previewFeedTypes'

// Hoisted so the defaults keep a stable identity across renders. Inline `[]`
// defaults would hand every render a fresh array, and consumers key effects off
// this context (`useIdentify` has it in a dependency list).
const NO_ITEMS: FeedItem[] = []
const NO_FOLLOWING_IDS: string[] = []

export function PreviewFeedProvider({
  children,
  items = NO_ITEMS,
  pages,
  token = null,
  followingIds = NO_FOLLOWING_IDS,
  identifyStatus = 'success',
}: PreviewFeedData & { children: ReactNode }) {
  const value = useMemo(
    () => ({ items, pages, token, followingIds, identifyStatus }),
    [items, pages, token, followingIds, identifyStatus],
  )

  return <PreviewFeedContext.Provider value={value}>{children}</PreviewFeedContext.Provider>
}
